'use client';

import { cn } from '@/exxonim/utils/cn';

/**
 * SuccessCheck - a calm, timeless confirmation mark.
 * The soft ring fades in, then the tick draws itself.
 * No bounce, no confetti - just a quiet "done".
 */
export function SuccessCheck({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center rounded-full bg-accent-soft text-accent',
        className,
      )}
      aria-hidden="true"
    >
      <svg
        className="w-1/2 h-1/2"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M8 12.5l2.5 2.5L16 9" className="animate-draw-check" />
      </svg>
    </span>
  );
}
